import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT, parseDate } from "app/infrastructure/data/date";

export const formatLockedDate = (date: string, locale: string): string => {
  if (typeof date !== 'string'){
    return undefined;
  }

  const parsedDate = parseDate(date);
  const formattedDate = new Intl.DateTimeFormat(locale, DEFAULT_DATE_FORMAT).format(parsedDate);
  const formattedTime = new Intl.DateTimeFormat(locale, DEFAULT_TIME_FORMAT).format(parsedDate);
  return parsedDate ? `${formattedDate} ${formattedTime}` : undefined;
};
